export { default as DefaultFooter } from './DefaultFooter';
